import React, { useState } from 'react'
import { getInitials } from '../constant/constant';

const LineChartV2 = ({ data, label, isLoading, onAttrClick, onTitleClick }) => {

    const [hovered, setHovered] = useState(null);
    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-[200px] w-full">
                <div className="mini-spinner mt-3"></div>
            </div>
        );
    }

    if (!isLoading && data.length === 0) {
        return (
            <div className="flex items-center justify-center h-[200px] w-full">
                No data available
            </div>
        );
    }


    return (
        <>
            <div key={label} className="flex justify-start items-center flex-col mt-5 gap-5 overflow-y-auto h-[350px]">
                {data && data.length > 0 && data.map((item, index) => (
                    <>
                        <div className={`w-full ${index === 0 ? "mt-5" : ""}`}>
                            <div className='flex items-center justify-between relative'>
                                <div className="flex items-center space-x-[10px]">
                                    <div className="w-3 h-3 rounded" style={{ "backgroundColor": '#D6E6F2' }}></div>
                                    <div className="text-[#373737] font-mont font-semibold lowercase cursor-pointer first-letter:uppercase"
                                        onClick={(e) => {
                                            onTitleClick && onTitleClick(item);
                                        }}>{item.name}</div>
                                </div>

                                <div className="flex items-center justify-between mt-[-10px]">

                                    {item.attributes && item.attributes.length > 0 && item.attributes.slice(0, 3).map((attr, attr_index) => {
                                        const uniqueId = `${index}-${attr_index}-${attr.patientTrialJuncID}`;
                                        return (
                                            <div
                                                key={uniqueId}
                                                className="relative"
                                                onMouseEnter={() => setHovered(uniqueId)}
                                                onMouseLeave={() => setHovered(null)}
                                                onClick={(e) => {
                                                    onAttrClick && onAttrClick(attr);
                                                }}
                                            >

                                                <span
                                                    className={`dashboard-chart-avatars cursor-pointer -ml-4 transition-transform duration-300 hover:-translate-y-1 hover:scale-110 hover:z-50 z-[-1]`}
                                                    style={{ color: attr_index % 2 === 0 ? "#6764AB" : "#AC7EBC" }}
                                                >
                                                    {getInitials(attr.firstName + " " + attr.lastName)}
                                                </span>

                                                {hovered === uniqueId && (
                                                    <div className={`absolute !text-[12px] font-semibold top-[30px] left-[-50px] -translate-x-1/2 bg-white shadow-lg px-3 py-2 rounded-md text-sm text-gray-800 z-[99] whitespace-nowrap`}>
                                                        {attr.firstName + " " + attr.lastName}
                                                    </div>
                                                )}
                                            </div>)
                                    })}
                                    {item.attributesCount && item.attributesCount > 3 && (
                                        <div
                                            key={index + "total_count"}
                                            className="relative"
                                            onMouseEnter={() => setHovered(index + "total_count")}
                                            onMouseLeave={() => setHovered(null)}
                                            onClick={(e) => {
                                                onTitleClick && onTitleClick(item);
                                            }}
                                        >

                                            <span
                                                className={`dashboard-chart-avatars cursor-pointer -ml-4 transition-transform duration-300 hover:-translate-y-1 hover:scale-110 hover:z-50`}
                                                style={{ color: "#1A1A1B" }}
                                            >
                                                {item.attributesCount > 50 ? `50+` : `${item.attributesCount}`}
                                            </span>

                                            {hovered === index + "total_count" && (
                                                <div
                                                    onClick={(e) => {
                                                        onTitleClick && onTitleClick(item);
                                                    }} className={`absolute cursor-pointer !text-[12px] font-semibold ${index === data.length - 1 ? "top-[0px]" : "top-[30px]"}  left-[-60px] -translate-x-1/2 bg-white shadow-lg px-3 py-2 rounded-md text-sm text-gray-800 z-[99] whitespace-nowrap`}>
                                                    View All {item.attributesCount} {label}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                </div>

                            </div>

                            <div className="w-full bg-gray-200 rounded-sm mt-[5px] h-2">
                                <div className="relative w-full">
                                    {/* Progress bar (hover target) */}
                                    <div
                                        className="h-2 rounded-sm bg-[#245CEA] relative group"
                                        style={{ width: `${item.percentage}%` }}
                                    >
                                        {/* Tooltip */}
                                        <span
                                            className="absolute -top-10 pointer-events-none
                                            z-[999999] px-[10px] py-[9px] text-[#fff] text-[12px] 
                                            bg-[#245CEA] whitespace-nowrap rounded-md font-semibold h-[37px] 
                                            shadow-[0_0_3px_#dddddd] px-2 py-1 opacity-0
                                            group-hover:opacity-100 transition"
                                            style={{
                                                left: item.percentage < 10 ? "30px" : "50%", // shift right if too small
                                                transform: "translateX(-50%)",
                                            }}
                                        >
                                            {item.percentage}%
                                        </span>
                                    </div>
                                </div>



                            </div>
                        </div>

                    </>
                ))}
            </div>
        </>
    )
}

export default LineChartV2;